/* Vendor files ------------------------------------ */

// import svg4everybody from './vendor/svg4everybody.js';
import hideOnScroll from './partial/hide-on-scroll.js';
// import changeOnScroll from './partial/header-change-on-scroll.js';
import hamburgerMenu from './partial/hamburger-menu';
import anchorHighlight from './partial/anchor-highlight-section.js';

// Move header top links on mobile
$(document).ready(function () {
	function movePaste() {
		var currentWidth = window.innerWidth;
		if (currentWidth < 900) {
			$('.js-main-nav').append($('.widget_product_search'));
			$('.js-main-nav .header__menu').append($('.header__top-link'));
		} else {
			$('.header__wrap').append($('.widget_product_search'));
			$('.header__wrap').append($('.header__top-link'));
		}
	}
	movePaste();
	$(window).resize(movePaste);

	function varCreate() {
		var headerMobile = document.querySelector('.header__wrap');
		var headerHeight = headerMobile.clientHeight;

		var header = document.querySelector('.mainHeader');
		var height = header.clientHeight;

		document.documentElement.setAttribute(
			'style',
			`--header-height-mobile: ${headerHeight}px;
		--header-height: ${height}px`
		);
	}
	varCreate();
	$(window).resize(varCreate);
});

$('.link__select').hover(function () {
	var isHovered = $(this).is(':hover');
	if (isHovered) {
		$(this).children('ul').toggleClass('is-active');
	} else {
		$(this).children('ul').toggleClass('is-active');
	}
});

// Open url via select
$(function () {
	// bind change event to select
	$('#dynamic_select').on('change', function () {
		var url = $(this).val(); // get selected value
		if (url) {
			// require a URL
			window.location = url; // redirect
		}
		return false;
	});
});
